import { type FC } from "react";
import { SectionTitle } from "@userFrontend/components/SectionTitle";
import * as styles from "./styles.css";
import { ReviewContent } from "./uiParts/ReviewContent/index";
import { type Props } from "./type";

export const DecidingFactors: FC<Props> = ({
  questions,
  decidingFactorsValues,
  handleCheckboxChange,
  decidingFactorsErrorText,
  decidingFactorsRef,
}) => {
  return (
    <div className={styles.sectionOuter}>
      <SectionTitle text="応募の決め手" />
      <div className={styles.container}>
        <ReviewContent
          questions={questions}
          categoryName="decidingFactors"
          checkboxValues={{ decidingFactors: decidingFactorsValues }}
          handleCheckboxChange={handleCheckboxChange}
          errorText={decidingFactorsErrorText}
          containerRef={decidingFactorsRef}
        />
      </div>
    </div>
  );
};
